import { BrowserRouter } from "react-router-dom";
import Router from "./components/GlobalComponents/Router/AppRouter";
import './App.scss'
import 'swiper/swiper-bundle.css';
import SwiperCore, { Autoplay } from 'swiper';
function App() {
  SwiperCore.use([Autoplay])
  return (
    <div >
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </div>
  );
}

export default App;
